import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;

  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  font-size: 14px !important;
  font-weight: 400 !important;
  font-style: normal !important;

  color: #000000;
  background-color: #cccccc;
`

export const Child = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 45px;

  color: #000000;
  background-color: #cccccc;

  display: flex;
  justify-content: space-around;
  align-items: center;

  &:first-child {
    position: relative;

    z-index: 99;
  }
`

export const HeaderBtn = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;

  > i {
    font-size: 22px;
    cursor: pointer;
    margin-right: 5px;
  }

  > span {
    cursor: pointer;
  }

  @media screen and (max-width: 500px) {
    > span {
      display: none;
    }
  }
`

export const HeaderText = styled.div`
  width: 700px;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media screen and (max-width: 990px) {
    width: 500px;
  }

  @media screen and (max-width: 768px) {
    width: 350px;
  }

  @media screen and (max-width: 640px) {
    width: 200px;
    margin: 0 auto;
  }

  @media screen and (max-width: 450px) {
    width: 150px;
  }
`